import { InspectorControls } from '@wordpress/block-editor';
import {
	PanelBody,
	SelectControl,
	RangeControl,
	ToggleControl,
	__experimentalUnitControl as UnitControl,
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import { FLIP_TRIGGERS, FLIP_DIRECTIONS } from '../constants';

export default function Settings( { attributes, setAttributes } ) {
	const {
		flipTrigger,
		flipDirection,
		animationDuration,
		heightMode,
		fixedHeight,
		cardWidth,
	} = attributes;

	return (
		<InspectorControls>
			<PanelBody title={ __( 'Flip Card Settings', 'brandy-blocks' ) }>
				<SelectControl
					label={ __( 'Flip Trigger', 'brandy-blocks' ) }
					value={ flipTrigger }
					options={ FLIP_TRIGGERS }
					onChange={ ( value ) =>
						setAttributes( { flipTrigger: value } )
					}
				/>
				<SelectControl
					label={ __( 'Flip Direction', 'brandy-blocks' ) }
					value={ flipDirection }
					options={ FLIP_DIRECTIONS }
					onChange={ ( value ) =>
						setAttributes( { flipDirection: value } )
					}
				/>
				<RangeControl
					label={ __( 'Animation Duration (s)', 'brandy-blocks' ) }
					value={ animationDuration }
					onChange={ ( value ) =>
						setAttributes( { animationDuration: value } )
					}
					min={ 0.3 }
					max={ 1.5 }
					step={ 0.1 }
				/>
				<ToggleControl
					label={ __( 'Fixed Height', 'brandy-blocks' ) }
					checked={ heightMode === 'fixed' }
					onChange={ ( checked ) =>
						setAttributes( {
							heightMode: checked ? 'fixed' : 'auto',
						} )
					}
				/>
				{ heightMode === 'fixed' && (
					<UnitControl
						label={ __( 'Height', 'brandy-blocks' ) }
						value={ fixedHeight }
						onChange={ ( value ) =>
							setAttributes( { fixedHeight: value } )
						}
						units={ [
							{ value: 'px', label: 'px', default: 450 },
							{ value: 'vh', label: 'vh', default: 50 },
							{ value: 'rem', label: 'rem', default: 25 },
						] }
					/>
				) }
				<UnitControl
					label={ __( 'Card Width', 'brandy-blocks' ) }
					value={ cardWidth }
					onChange={ ( value ) =>
						setAttributes( { cardWidth: value } )
					}
					units={ [
						{ value: 'px', label: 'px', default: 350 },
						{ value: '%', label: '%', default: 100 },
						{ value: 'rem', label: 'rem', default: 22 },
					] }
				/>
			</PanelBody>
		</InspectorControls>
	);
}
